import React, { useEffect, useState } from "react";
import { Table, Row, Col, Space, Tag } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import columns from "@staticData/admin/adminInvoicesTableColumns";
import moment from "moment-jalaali";

function AdminInvoicesListTable({
  data,
  onPageChange,
  currentPage,
  onSort,
  loading,
  onOpenDrawer,
}) {
  const [tableData, setTableData] = useState([]);
  const { getInvoicesCount: count, getInvoices: invoices } = data;

  useEffect(() => {
    const initialTableData = [];
    invoices.map((invoice) => {
      const {
        id,
        createdAt,
        updatedAt,
        paidAt,
        cancelAt,
        discountAmount,
        finalAmount, 
        amountRial,
        description,
        invoiceType,
        user,
      } = invoice;
      initialTableData.push({
        key: id,
        updatedAt: moment(updatedAt).format("jYYYY/jMM/jDD"),
        createdAt: moment(createdAt).format("jYYYY/jMM/jDD"),
        paidAt: paidAt ? moment(paidAt).format("jYYYY/jMM/jDD") : <Tag color="orange">پرداخت نشده</Tag>,
        cancelAt: cancelAt ? moment(cancelAt).format("jYYYY/jMM/jDD") : " - ",
        finalAmount:  finalAmount?.toLocaleString(),
        invoiceType,
        description,
        payer: user.name,
        details: (
          <Space>
            <a onClick={() => onOpenDrawer(id)}>
              <EyeOutlined />
            </a>
          </Space>
        ),
      });
    });
    setTableData(initialTableData);
  }, [invoices]);
  const onChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "sort") {
      onSort(sorter);
    }
    if (extra.action === "paginate") {
      onPageChange(pagination.current);
    }
  };
  return (
    <>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={{
              total: count,
              current: currentPage,
              showSizeChanger: false,
            }}
            onChange={onChange}
            loading={loading}
            scroll={{ x: 600 }}
          />
        </Col>
      </Row>
    </>
  );
}

export default AdminInvoicesListTable;
